import { IonApp, setupIonicReact } from "@ionic/react";
import { PreviewDeploymentVersion } from "@9amhealth/shared";
import { Blac } from "blac-next";
import type { ReactElement, ReactNode } from "react";
import React, { useEffect } from "react";
import { I18nProvider } from "react-aria";
import envVariables from "src/lib/envVariables";
import {
  getSupportedUserLocale,
  initializeLocalisation
} from "src/lib/i18next";
import { DeviceTrackingBloc } from "src/state/DeviceTrackingBloc/DeviceTrackingBloc";
import "src/state/state";
import { appVersionState } from "src/state/state";
import AppDebug from "src/ui/components/AppDebug/AppDebug";
import CustomSuspense from "src/ui/components/CustomSuspense/CustomSuspense";
import MainRouter from "src/ui/components/MainRouter/MainRouter";
import CustomErrorBoundary from "src/ui/components/SentryBoundary/CustomErrorBoundary";
import Toast from "src/ui/components/Toast/Toast";
import AppDialogTarget from "../AppDialog/AppDialogTarget";

setupIonicReact({});
void initializeLocalisation();

const IonAppReact19Compatible = IonApp as unknown as React.FC<{
  children?: ReactNode;
}>;

const Async = {
  AsyncExtras: React.lazy(
    async () => import("src/ui/components/App/AppAsyncExtras")
  )
};

function App(): ReactElement {
  useEffect(() => {
    void appVersionState.checkForUpdate();
    void Blac.getBloc(DeviceTrackingBloc).collectAndTrack();
  }, []);
  return (
    <CustomErrorBoundary>
      <IonAppReact19Compatible>
        <I18nProvider locale={getSupportedUserLocale()}>
          <nine-helper></nine-helper>
          <Toast />
          <CustomSuspense>
            <AppDialogTarget />
          </CustomSuspense>
          <CustomSuspense>
            <Async.AsyncExtras />
          </CustomSuspense>
          <MainRouter />
          <CustomSuspense>
            <div id="actionButtonTarget" />
          </CustomSuspense>
        </I18nProvider>
      </IonAppReact19Compatible>
      <AppDebug />
      <PreviewDeploymentVersion
        showOnDevelop={envVariables.ENV_NAME === "dev-web"}
        developUrl="https://app.dev.join9am.com/"
      />
      <div id="date-time-picker-target" />
    </CustomErrorBoundary>
  );
}

export default App;
